import React from 'react';
import { Tabs } from 'antd';
import GraphDistribution from '../../components/GraphDistribution';
import GraphAmountCategory from '../../components/GraphAmountCategory';
const TabPane = Tabs.TabPane;

class CategoryOverviewRender extends React.Component {

  render() {
    const { t, currentYear, allYears, gradeSelected } = this.props
    const COLORS = ['#541791', '#07B229', '#D8889B', '#002940', '#6C3C11'];
    const yearTabs = gradeSelected ? [{text: 'Selected class'}] : allYears

    return (
      <div>
        <div style={styles.container} className="card-container">
          <Tabs
              type="card"
              activeKey={currentYear.year && !gradeSelected  ? currentYear.year.text : 'Selected class'}
              onTabClick={(year) => !gradeSelected && this.props.changeYear(allYears.filter( item => item.text === year)[0])}
            >
            {yearTabs && yearTabs.map(year => (
              <TabPane
                style={styles.yearbox}
                tab={year.text}
                key={year.text}>
                <p style={styles.title}>{t('Distribution Per Category')}</p>
                <div style={styles.inner}>
                  <GraphDistribution data={this.props.distribution} t={t} colors={COLORS} />
                  <div style={styles.colorbox}>
                    {this.props.categoryList && this.props.categoryList.map((category, i) =>
                      <p><div className="circle" style={{ backgroundColor: COLORS[i] }} /> {t(category)}</p>
                    )}
                  </div>
                </div>
              </TabPane>
            ))}
          </Tabs>
        </div>

        <div style={styles.container2}>
          <p style={styles.title2}>{t('Amount Per Category')}</p>
          <GraphAmountCategory t={this.props.t} data={this.props.amount} />
        </div>
      </div>
    )
  }
}

const COLORS = ['#541791', '#07B229', '#D8889B', '#002940', '#6C3C11'];
export default CategoryOverviewRender;



const styles = {

  yearbox: {
    backgroundColor: 'white',
    padding: '40px 20px'
  },

  container: {
    margin: '0px 20px 20px 20px'
  },

  container2: {
    margin: '20px',
    backgroundColor: 'white',
    padding: '40px',
    height: 490
  },

  title: {
    fontSize: '20px',
    color: '#485465',
    fontWeight: 600,
    marginLeft: 100,
    paddingTop: 30
  },

  title2: {
    fontSize: '20px',
    color: '#485465',
    fontWeight: 600,
    marginLeft: 100
  },

  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  },

  colorbox: {
    fontSize: '16px'
  }

}



// WEBPACK FOOTER //
// ./src/components/CategoryOverviewRender/index.jsx